import { render, staticRenderFns } from "./ParticipationRelationTypeEditCard.vue?vue&type=template&id=31b937cd&scoped=true"
import script from "./ParticipationRelationTypeEditCard.vue?vue&type=script&lang=js"
export * from "./ParticipationRelationTypeEditCard.vue?vue&type=script&lang=js"
import style0 from "./ParticipationRelationTypeEditCard.vue?vue&type=style&index=0&id=31b937cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b937cd",
  null
  
)

export default component.exports